import React, { useEffect, useState } from 'react';
import { Button, Col, Icon, RSelect, Row } from '../../../../../../components/Component';
import { Alert, Spinner } from 'reactstrap';
import TextInput from '../../../../../components/inputs/TextInput';
import ListText from '../../../text/ListText';
import { fail_product_list, loading_product_list, reset_product_list, success_product_list } from '../../../../../../reducers/dashboard_reducers/products/product_list_Slice';
import { CREATE_GOODS_RECEIVED_NOTE_PRODUCT_ACCESS_DENIED_MSG, CREATE_GOODS_RECEIVED_NOTE_PRODUCT_ERR_MSG, CREATE_GOODS_RECEIVED_NOTE_PRODUCT_SUCCESS_MSG, RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG, RETRIEVE_PRODUCTS_LIST_ERR_MSG, RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG, RETRIEVE_WAREHOUSE_STORAGE_LIST_ACCESS_DENIED_MSG, RETRIEVE_WAREHOUSE_STORAGE_LIST_ERR_MSG, RETRIEVE_WAREHOUSE_STORAGE_LIST_SUCCESS_MSG } from '../../../../../../constants/success_error_messages_consts';
import { CREATE_GOODS_RECEIVED_NOTE_PRODUCT_API, RETRIEVE_ACTIVE_PRODUCT_LIST, RETRIEVE_SPECIFC_BRANCH_STORAGE_LIST_BY_STATUS_ID_API } from '../../../../../../api/api_data';
import { employee_dashboard_actions_helper } from '../../../../../../actions/actions_helper';
import { useDispatch } from 'react-redux';
import { messageToast, rSelectMapFun } from '../../../../../../utils/Utils';
import { useSelector } from 'react-redux';
import * as app_consts from "../../../../../../constants/react_app_consts";
import { convertPackagingUnits, retreive_rSelectVariables } from '../../../../../../utils/functionalUtils';
import { fail_retrieve_warehouse_storages_list, loading_retrieve_warehouse_storages_list, reset_retrieve_warehouse_storages_list, success_retrieve_warehouse_storages_list } from '../../../../../../reducers/dashboard_reducers/warehouse/retrieve_warehouse_storages_list_Slice';
import { fail_add_goods_received_products, loading_add_goods_received_products, reset_add_goods_received_products, success_add_goods_received_products } from '../../../../../../reducers/dashboard_reducers/goods_received/add_goods_received_products_Slice';

const initialState = { product_id: "", product_type: "", product: "", warehouse_storage_id: "", warehouse_storage: "", total_capacity_selected_measurement: "", total_capacity_in_mt: "", uom: "", unit_measurement_id: "", goods_received_id: "", uom_label: "", warehouse_storage_label: "", packet_size: "", packet_measurement_in_kilos: "" };

const resolveSelectedTicketNetWeight = (pageData = {}) => {
    const netWeightCandidates = [
        pageData?.weighBridgeFormData?.net_weight,
        pageData?.weighBridgeFormData?.weighbridge_ticket_data?.net_weight,
        pageData?.weighBridgeFormData?.weighbridge_ticket_data?.netWeight,
        pageData?.continue_processing_data?.net_weight,
        pageData?.continue_processing_data?.weighbridge_ticket_data?.net_weight,
        pageData?.continue_processing_data?.weighbridge_ticket_data?.netWeight,
    ];

    const resolvedNetWeight = netWeightCandidates.find(
        (value) => value !== null && value !== undefined && value !== "",
    );

    if (resolvedNetWeight === undefined)
    {
        return "";
    }

    const parsedNetWeight = parseFloat(resolvedNetWeight);
    return Number.isFinite(parsedNetWeight) ? parsedNetWeight.toFixed(2) : String(resolvedNetWeight);
};

const resolveGoodsReceivedId = (pageData = {}) => {
    const candidates = [
        pageData?.continue_processing_data?.goods_received_id,
        pageData?.continue_processing_data?.goods_received?.goods_received_id,
        pageData?.continue_processing_data?.goods_reeived_data?.goods_received_id,
        pageData?.weighBridgeFormData?.goods_received_id,
        pageData?.weighBridgeFormData?.goods_received?.goods_received_id,
        pageData?.weighBridgeFormData?.goods_reeived_data?.goods_received_id,
    ];

    return candidates.find((value) => value !== null && value !== undefined && value !== "") || "";
};

const resolveGoodsReceivedRefNumber = (pageData = {}) => {
    const candidates = [
        pageData?.continue_processing_data?.goods_received_ref_number,
        pageData?.continue_processing_data?.goods_received?.goods_received_ref_number,
        pageData?.continue_processing_data?.goods_reeived_data?.goods_received_ref_number,
        pageData?.weighBridgeFormData?.goods_received_ref_number,
        pageData?.weighBridgeFormData?.goods_received?.goods_received_ref_number,
        pageData?.weighBridgeFormData?.goods_reeived_data?.goods_received_ref_number,
    ];

    return candidates.find((value) => value !== null && value !== undefined && value !== "") || "";
};

const isGrainProductType = (productType = "") =>
    String(productType || "").trim().toLowerCase() === "grain";

const AddGoodsReceivedProductsModal = ({ page_data, openModal, successFunction }) => {

    const [step, setStep] = useState(1);
    const [errorVal, setError] = useState("");
    const [formData, setFormData] = useState(initialState);
    const [productTypeList, setProductTypeList] = useState([]);
    const [productListLoading, setProductListLoading] = useState(true);
    const [productsList, setProductsList] = useState([]);
    const [uom, setUom] = useState([]);
    const [warehousestorageslist, setWarehouseStoragesList] = useState([]);
    const [addLoading, setAddLoading] = useState(false);
    const dispatch = useDispatch();
    const [api_data, setRetrievedData] = useState([]);
    const [product_data, setProductData] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [packet_size_list, setPacketSizeList] = useState([]);
    const selectedTicketNetWeight = resolveSelectedTicketNetWeight(page_data);
    const goodsReceivedId = resolveGoodsReceivedId(page_data);
    const goodsReceivedRefNumber = resolveGoodsReceivedRefNumber(page_data);
    const grainProductSelected = isGrainProductType(formData?.product_type);

    //     // Useffect to Run when the Modal Opens
    useEffect(() => {
        // setRetrievedData(page_data);
        if (openModal && page_data)
        {
            // Retrieve Product List
            dispatch(
                employee_dashboard_actions_helper(
                    loading_product_list,
                    success_product_list,
                    fail_product_list,
                    RETRIEVE_PRODUCTS_LIST_ERR_MSG,
                    RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG,
                    app_consts.GET,
                    RETRIEVE_ACTIVE_PRODUCT_LIST,
                    null,
                    RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG
                )
            );

            // Retrieve Warehouse Storage List
            dispatch(
                employee_dashboard_actions_helper(
                    loading_retrieve_warehouse_storages_list,
                    success_retrieve_warehouse_storages_list,
                    fail_retrieve_warehouse_storages_list,
                    RETRIEVE_WAREHOUSE_STORAGE_LIST_ERR_MSG,
                    RETRIEVE_WAREHOUSE_STORAGE_LIST_SUCCESS_MSG,
                    app_consts.POST,
                    RETRIEVE_SPECIFC_BRANCH_STORAGE_LIST_BY_STATUS_ID_API,
                    { branch_location_id: page_data?.continue_processing_data?.branch_location_id, warehouse_storage_status_id: app_consts.ACTIVATE_ACCOUNT_ID },
                    RETRIEVE_WAREHOUSE_STORAGE_LIST_ACCESS_DENIED_MSG,
                    app_consts.MAP,
                    app_consts.BRANCH_STORAGES_TYPES_MAP
                )
            );
        }
    }, [openModal, page_data]);

    //Listen to State of Product List
    const product_list = useSelector((state) => state.product_list.product_list);

    useEffect(() => {
        if (product_list.status !== app_consts.IDLE)
        {
            if (product_list.status === app_consts.LOADING)
            {
                setProductListLoading(true);
            } else
            {
                setProductListLoading(false);
                if (product_list.status === app_consts.FAIL)
                {
                    messageToast(product_list.message, app_consts.FAIL);
                } else if (product_list.status === app_consts.SUCCESS)
                {
                    setProductData(product_list.data);
                }
                dispatch(reset_product_list());
            }
        }
    }, [product_list]);


    const warehouse_storages_list = useSelector((state) => state.retrieve_warehouse_storages_list.retrieve_warehouse_storages_list);

    useEffect(() => {
        if (warehouse_storages_list.status !== app_consts.IDLE)
        {
            if (warehouse_storages_list.status === app_consts.LOADING)
            {
                // setLoading(true);
            } else
            {
                // setLoading(false);
                if (warehouse_storages_list.status === app_consts.FAIL)
                {
                    messageToast(warehouse_storages_list.message, app_consts.FAIL);
                } else if (warehouse_storages_list.status === app_consts.SUCCESS)
                {
                    if (warehouse_storages_list.data?.length === 0)
                    {
                        messageToast("No Warehouse Storage Sites Found.", app_consts.FAIL);
                    }
                    else
                    {
                        setWarehouseStoragesList(warehouse_storages_list.data);
                    }
                }
                dispatch(reset_retrieve_warehouse_storages_list());
            }
        }
    }, [warehouse_storages_list]);

    // Product Data listener
    useEffect(() => {
        if (product_data) 
        {
            handleProductType();
        }
    }, [product_data]);

    const handleProductType = async () => {
        let mappedData = [];


        await Promise.all(
            product_data?.map(async (data_to_map) => {
                const { label, value } = retreive_rSelectVariables(app_consts.PRODUCT_TYPE_MAP, data_to_map);
                const result = await rSelectMapFun(label, value);
                mappedData.push(result);
            })
        );

        setProductTypeList(mappedData);
    };

    // Handle Preview
    const handlePreview = () => {
        setError("");
        setStep(2);
    };

    // Handle Product Type Change
    const handleProductTypeChange = async (value, label) => {
        if (value && label) 
        {
            setFormData({ ...formData, ["product_type"]: label, ["product_id"]: "", ["product"]: "", ["warehouse_storage_id"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: "", ["uom"]: "", ["unit_measurement_id"]: "", ["uom_label"]: "", ["packet_measurement_in_kilos"]: "", ["packet_size"]: "" });
            let mappedData = [];

            const filtereredData = product_data?.filter((data) => data.product_type_id === value);

            setSelectedProducts(filtereredData[0]?.products);

            await Promise.all(
                filtereredData[0]?.products?.map(async (data_to_map) => {
                    const { label, value } = retreive_rSelectVariables(app_consts.PRODUCTS_MAP, data_to_map);
                    const result = await rSelectMapFun(label, value);
                    mappedData.push(result);
                })
            );
            setProductsList(mappedData);
        }
        else
        {
            setFormData({ ...formData, ["product_type"]: "", ["product_id"]: "", ["product"]: "", ["warehouse_storage_id"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: "", ["uom"]: "", ["unit_measurement_id"]: "", ["uom_label"]: "", ["packet_measurement_in_kilos"]: "", ["packet_size"]: "" });
        }
    };

    // Handle Product Change
    const handleProductChange = async (value, label) => {
        if (value && label) 
        {
            setFormData({ ...formData, ["product_id"]: value, ["product"]: label, ["warehouse_storage_id"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: "", ["uom"]: "", ["unit_measurement_id"]: "", ["uom_label"]: "", ["packet_measurement_in_kilos"]: "", ["packet_size"]: "" });
            let mappedData = [];

            const filtereredData = selectedProducts?.filter((data) => data.product_id === value);

            await Promise.all(
                filtereredData?.map(async (data_to_map) => {
                    // Map Pum Liist
                    data_to_map?.pum_list?.map(async (map) => {
                        const { label, value } = retreive_rSelectVariables(app_consts.UOM_MAP, map);
                        const result = await rSelectMapFun(label, value);
                        mappedData.push(result);
                    });
                })
            );
            setUom(mappedData);
        }
        else
        {
            setFormData({ ...formData, ["product_id"]: "", ["product"]: "", ["warehouse_storage_id"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: "", ["uom"]: "", ["unit_measurement_id"]: "", ["uom_label"]: "", ["packet_measurement_in_kilos"]: "", ["packet_size"]: "" });
        }
    };

    // Handle Unit of Measurem Chanage
    const handleUomChange = async (value, label) => {
        if (value && label) 
        {
            setFormData({ ...formData, ["warehouse_storage_id"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: "", ["uom"]: value, ["unit_measurement_id"]: value, ["uom_label"]: label, ["packet_measurement_in_kilos"]: "", ["packet_size"]: "" });

            let mappedData = [];

            const filtereredData = selectedProducts
                ?.filter(
                    (data) =>
                        data.product_id === formData.product_id &&
                        data?.pum_list?.some((pum) => pum?.unit_measurement_id === value)
                )
                ?.flatMap((data) =>
                    data.pum_list.filter((pum) => pum?.unit_measurement_id === value)
                );

            await Promise.all(
                filtereredData?.map(async (data_to_map) => {
                    data_to_map?.uom_details?.map((async (final_data) => {
                        const { label, value } = retreive_rSelectVariables(app_consts.PACKET_SIZE_MAP, final_data);
                        const result = await rSelectMapFun(label, value);
                        mappedData.push(result);
                    }));
                })
            );
            setPacketSizeList(mappedData);
        }
        else
        {
            setFormData({ ...formData, ["warehouse_storage_id"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: "", ["uom"]: "", ["unit_measurement_id"]: "", ["uom_label"]: "", ["packet_measurement_in_kilos"]: "", ["packet_size"]: "" });
        }
    };

    // Handle Storage Type Change
    const handleStorageTypeChange = (value, label) => {
        if (value && label) 
        {
            setFormData({ ...formData, ["warehouse_storage_id"]: value, ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: label, ["packet_measurement_in_kilos"]: "", ["packet_size"]: "" });
        }
        else
        {
            setFormData({ ...formData, ["warehouse_storage_id"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: "", ["packet_measurement_in_kilos"]: "", ["packet_size"]: "" });
        }
    };

    const handlePacketSizeChange = async (value, label) => {
        if (value && label) 
        {

            let finalString = "";

            const filteredData = selectedProducts?.filter(
                (data) => data.product_id === formData.product_id
            );

            for (const dataToMap of filteredData || [])
            {
                for (const lastData of dataToMap?.pum_list || [])
                {
                    const result = lastData?.uom_details?.find(
                        (finalData) => finalData.packet_size === value
                    );

                    if (result)
                    {
                        finalString = result?.measurement_in_kilos; // Assign the unique result to finalString
                        break; // Exit the loop once the string is found
                    }
                }

                if (finalString)
                {
                    break; // Exit the outer loop if the string is already found
                }
            }

            setFormData({
                ...formData,
                ["packet_measurement_in_kilos"]: finalString,
                ["packet_size"]: value,
                ["total_capacity_selected_measurement"]: "",
                ["total_capacity_in_mt"]: grainProductSelected ? selectedTicketNetWeight : "",
            });
        }
        else
        {
            setFormData({ ...formData, ["packet_measurement_in_kilos"]: "", ["packet_size"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "" });
        }
    };

    // Handle Change
    const handleChange = (e) => {
        if (e.target.name === "total_capacity_selected_measurement")
        {
            if (grainProductSelected)
            {
                setFormData({ ...formData, ["total_capacity_selected_measurement"]: e.target.value });
            }
            else
            {
                // Convert to Metric Tonnes
                const metric_tonne_conversion = parseFloat(
                    ((formData?.packet_measurement_in_kilos || 0) / 1000) * Number(e.target.value)
                ).toFixed(2);


                setFormData({ ...formData, ["total_capacity_in_mt"]: metric_tonne_conversion, ["total_capacity_selected_measurement"]: e.target.value });
            }
        }
        else if (e.target.name === "total_capacity_in_mt")
        {
            setFormData({ ...formData, ["total_capacity_in_mt"]: e.target.value });
        }
    };

    const handleOnblur = (e) => {
        if (e.target.name === "total_capacity_in_mt")
        {
            if (e.target.value)
            {
                setFormData({ ...formData, ["total_capacity_in_mt"]: parseFloat(e.target.value).toFixed(2) });
            }
            else
            {
                setFormData({ ...formData, ["total_capacity_in_mt"]: "" });
            }
        }
        else
        {
            if (e.target.value)
            {
                setFormData({ ...formData, [e.target.name]: parseFloat(e.target.value).toFixed(2) });
            }
            else
            {
                setFormData({ ...formData, [e.target.name]: "" });
            }
        }
    };

    //     // Handle Submit
    const handleSubmit = () => {
        const addProductPayload = {
            goods_received_id: goodsReceivedId,
            goods_received_ref_number: goodsReceivedRefNumber,
            product_id: formData.product_id,
            warehouse_storage_id: formData.warehouse_storage_id,
            unit_measurement_id: formData.unit_measurement_id || formData.uom,
            total_capacity_selected_measurement: formData.total_capacity_selected_measurement,
            packet_size: formData.packet_size,
            total_capacity_in_mt: formData.total_capacity_in_mt,
            uom: formData.uom,
        };

        console.log("ADD GOODS RECEIVED PRODUCT PAYLOAD =>", addProductPayload);
        console.log("ADD GOODS RECEIVED PRODUCT PAGE DATA =>", page_data);

        dispatch(
            employee_dashboard_actions_helper(
                loading_add_goods_received_products,
                success_add_goods_received_products,
                fail_add_goods_received_products,
                CREATE_GOODS_RECEIVED_NOTE_PRODUCT_ERR_MSG,
                CREATE_GOODS_RECEIVED_NOTE_PRODUCT_SUCCESS_MSG,
                app_consts.POST,
                CREATE_GOODS_RECEIVED_NOTE_PRODUCT_API,
                addProductPayload,
                CREATE_GOODS_RECEIVED_NOTE_PRODUCT_ACCESS_DENIED_MSG
            )
        );
    };

    // Listen to Reducer Changes
    const add_grn_products_listener = useSelector((state) => state.add_goods_received_products.add_goods_received_products);
    //
    useEffect(() => {
        if (add_grn_products_listener.status !== app_consts.IDLE)
        {
            if (add_grn_products_listener.status === app_consts.LOADING)
            {
                setError("");
                setAddLoading(true);
            } else
            {
                setAddLoading(false);
                if (add_grn_products_listener.status === app_consts.FAIL)
                {
                    console.log("ADD GOODS RECEIVED PRODUCT FAILURE =>", add_grn_products_listener);
                    setError(add_grn_products_listener.message);
                    messageToast(add_grn_products_listener.message, app_consts.FAIL);
                } else if (add_grn_products_listener.status === app_consts.SUCCESS)
                {
                    console.log("ADD GOODS RECEIVED PRODUCT SUCCESS =>", add_grn_products_listener);
                    messageToast(CREATE_GOODS_RECEIVED_NOTE_PRODUCT_SUCCESS_MSG, app_consts.SUCCESS);
                    successFunction(add_grn_products_listener.data);
                }
                dispatch(reset_add_goods_received_products());
            }
        }
    }, [add_grn_products_listener]);

    const getSelectedOption = (value, options) => {
        return options.find(option => option.value === value) || null;
    };


    return (
        <>
            <div className="d-flex justify-content-between mb-2">
                {step === 2 && (
                    <div
                        className="nk-block-head-sub mb-2"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                            e.preventDefault();
                            setStep(1);
                            setFormData(initialState);
                        }}
                    >
                        <Icon name="arrow-left" />
                        <span>back</span>
                    </div>
                )}
            </div>
            {errorVal && (
                <div className="mb-3 w-100">
                    <Alert color="danger" className="alert-icon">
                        <Icon name="alert-circle" /> {errorVal}{" "}
                    </Alert>
                </div>
            )}
            {step === 1 ? (
                <>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                        }}
                    >
                        <Row className="g-4">
                            <div className="form-label-group">
                                <label className="form-label text-soft fs-22px">Product Details</label>
                            </div>
                            <Col size={6} className="my-2">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">
                                        Product Type
                                    </label>
                                    <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
                                        <div className="w-100">
                                            <RSelect
                                                options={productTypeList}
                                                className="w-100"
                                                placeholder="Search"
                                                id="product_type"
                                                isLoading={productListLoading}
                                                onChange={(e) => { handleProductTypeChange(e.value, e.label); }}
                                                isDisabled={productListLoading}

                                            />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col size={6} className="my-2">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">
                                        Product
                                    </label>
                                    <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
                                        <div className="w-100">
                                            <RSelect
                                                options={productsList}
                                                className="w-100"
                                                placeholder="Search"
                                                id="product_id"
                                                onChange={(e) => { handleProductChange(e.value, e.label); }}
                                                isDisabled={!formData.product_type}
                                                value={getSelectedOption(formData.product_id, productsList)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col size={6} className="my-2">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="uom">
                                        Unit of Measure
                                    </label>
                                    <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
                                        <div className="w-100">
                                            <RSelect
                                                options={uom}
                                                className="w-100"
                                                placeholder="Search"
                                                id="uom"
                                                onChange={(e) => { handleUomChange(e.value, e.label); }}
                                                isDisabled={!formData.product_id}
                                                value={getSelectedOption(formData.uom, uom)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col size={6} className="my-2">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="warehouse_storage_id">
                                        Warehouse Storage Type
                                    </label>
                                    <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
                                        <div className="w-100">
                                            <RSelect
                                                options={warehousestorageslist}
                                                className="w-100"
                                                placeholder="Search"
                                                id="warehouse_storage_id"
                                                onChange={(e) => { handleStorageTypeChange(e.value, e.label); }}
                                                isDisabled={!formData.uom}
                                                value={getSelectedOption(formData.warehouse_storage_id, warehousestorageslist)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <div className="form-label-group">
                                <label className="form-label text-soft fs-22px">Measurement Details</label>
                            </div>
                            <Col size={6} className="my-2">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="warehouse_storage_id">
                                        Packet Size
                                    </label>
                                    <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
                                        <div className="w-100">
                                            <RSelect
                                                options={packet_size_list}
                                                className="w-100"
                                                placeholder="Search"
                                                id="packet_size"
                                                onChange={(e) => { handlePacketSizeChange(e.value, e.label); }}
                                                isDisabled={!formData.uom}
                                                value={getSelectedOption(formData.packet_size, packet_size_list)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <TextInput
                                parentClassName="mt-2"
                                label={`Density Weight in Kilos`}
                                id_val="packet_measurement_in_kilos"
                                type="number"
                                value={formData?.packet_measurement_in_kilos}
                                colSize="6"
                                disabled={true}
                                name="packet_measurement_in_kilos"
                                handleChange={handleChange}
                                onBlur={handleOnblur}
                            />
                            <TextInput
                                parentClassName="mt-2"
                                label={`Package/Container Number ${formData.packet_size ? `(${formData.packet_size})` : ""}`}
                                id_val="total_capacity_selected_measurement"
                                type="number"
                                value={formData?.total_capacity_selected_measurement}
                                colSize="6"
                                name="total_capacity_selected_measurement"
                                handleChange={handleChange}
                                onBlur={handleOnblur}
                            />
                            <TextInput
                                parentClassName="mt-2"
                                label="Goods Received Capacity (MT)"
                                id_val="total_capacity_in_mt"
                                maxlength="160"
                                type="number"
                                value={formData?.total_capacity_in_mt}
                                colSize="6"
                                name="total_capacity_in_mt"
                                disabled={!grainProductSelected}
                                handleChange={handleChange}
                                onBlur={handleOnblur}
                            />
                            <Col xl="12" className="d-flex justify-content-center">
                                <Button
                                    onClick={handlePreview}
                                    size="lg"
                                    type="submit"
                                    color="primary"
                                    disabled={!(
                                        formData.product_id &&
                                        formData.warehouse_storage_id &&
                                        formData.total_capacity_selected_measurement &&
                                        formData.total_capacity_in_mt &&
                                        formData.uom &&
                                        formData.packet_size
                                    )}
                                >
                                    Preview Product and Add
                                </Button>
                            </Col>
                        </Row>
                    </form>
                </>
            ) : step === 2 ? (
                <>
                    <ListText dataItem="data-item mySmall" label="Product Name" value={formData.product} />
                    <ListText dataItem="data-item mySmall" label="Product Type" value={formData.product_type} />
                    <ListText dataItem="data-item mySmall" label="Warehouse Storage Type" value={formData.warehouse_storage_label} />
                    <ListText dataItem="data-item mySmall" label="Unit of Measurement" value={formData.uom_label} />
                    <ListText dataItem="data-item mySmall" label="Packaging Size" value={formData.packet_size} />
                    <ListText dataItem="data-item mySmall" label={`Total Capacity ${formData.unit_measurement ? `(${formData.unit_measurement})` : ""}`} value={formData.total_capacity_selected_measurement} />
                    <ListText dataItem="data-item mySmall" label="Goods Received Capacity (MT)" value={formData.total_capacity_in_mt} />
                    <Col xl="12" className="d-flex justify-content-end mt-4 mr-2">
                        <Button onClick={handleSubmit} disabled={addLoading} color="primary">
                            {addLoading ? <Spinner size="sm" color="light" /> : "Add Product"}
                        </Button>
                    </Col>
                </>
            )
                :
                ""
            }

        </>
    );
};

export default AddGoodsReceivedProductsModal;
